/**
 * AngularJS related dependencies
 */
import 'angular';
import 'angular-sanitize';
import 'angular-animate';
import 'angular-resource';
import 'angular-ui-bootstrap';
import 'angularjs-slider';
/**
 * JS dependencies
 */
import 'jquery';
import 'lodash';
import qs from 'qs';
/**
 * SearchJS related code (importation order does matter here)
 */
import '../../../../../lib/assets/javascripts/devex/urls';
import '../../../../../lib/assets/javascripts/devex/browser_url';
import '../../../../../lib/assets/javascripts/devex/search/sorting';
import '../../../../../lib/assets/javascripts/devex/search/filter';
import '../../../../../lib/assets/javascripts/devex/search/pagination';
import '../../../../../lib/assets/javascripts/devex/search/searchJS';
/**
 * Devex services
 */
import '../../../../../lib/assets/javascripts/devex/angular/searchJS';
import '../../../../../lib/assets/javascripts/devex/angular/services/routes.service';
import '../../../../../lib/assets/javascripts/devex/angular/services/error_reporting.service';
import '../../../../../lib/assets/javascripts/devex/angular/models/alert_handling_service';
/**
 * Devex helpers
 */
import 'ui-select';
import '../../../../../lib/assets/javascripts/devex/ui-utils';
// Bookmarked searches directives dependencies
// lodash dependent
import '../../../../../lib/assets/javascripts/devex/angular/request_transformers';
import '../../../../../lib/assets/javascripts/devex/alerts.js';
/**
 * Devex AngularJS filters
 */
import '../../../../../lib/assets/javascripts/devex/angular/filters/lists';
import '../../../utilities/angular/days_ago';
/**
 * Devex AngularJS components/directives
 */
import '../../../../../lib/assets/javascripts/devex/angular/directives/ui-select';
import '../../../../../lib/assets/javascripts/devex/angular/directives/favorites';
import '../../../components/recruiter_contact_button/recruiter_contact_button.component';
import '../../../components/recruiter_folder_select/recruiter_folder_select.component';
import '../../../components/recruiter_notes_list/recruiter_notes_list.component';
import '../../../../../lib/assets/javascripts/devex/angular/directives/pagination/pagination.directive';
import '../../../../../lib/assets/javascripts/devex/angular/directives/pagination-info';

window.$.deparam = qs.parse;
